import React from "react";
import _get from "lodash.get";

import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";

import ContractActivationFields from "./ContractActivationFields";
import ContractAutoExpireFields from "./ContractAutoExpireFields";
import ContractDetailFields from "./ContractDetailFields";
import ContractInviteRequestsFields from "./ContractInviteRequestsFields";
import ContractPLLFields from "./ContractPLLFields";
import ContractOrganization from "./ContractOrganization";
import ContractSettingsFields, {
  useFieldDefault
} from "./ContractSettingsFields";
import useStylesUtil from "hooks/useStylesUtil";

// Component to apply parent contract defaults to form fields
const ParentContractDefaults = ({ parentContractDefaults }) => {
  // Contract detail fields
  useFieldDefault("seats", null, _get(parentContractDefaults, "seats"));

  // Auto expire fields
  useFieldDefault(
    "autoUsersInactive",
    null,
    _get(parentContractDefaults, "autoUsersInactive")
  );
  useFieldDefault(
    "usersActiveForDays",
    null,
    _get(parentContractDefaults, "usersActiveForDays")
  );

  // Settings fields
  useFieldDefault(
    "talkUploads",
    null,
    _get(parentContractDefaults, "talkUploads")
  );
  useFieldDefault(
    "communityAccess",
    null,
    _get(parentContractDefaults, "communityAccess")
  );
  useFieldDefault(
    "inviteEmailIntro",
    null,
    _get(parentContractDefaults, "inviteEmailIntro")
  );
  useFieldDefault(
    "inviteEmailOutro",
    null,
    _get(parentContractDefaults, "inviteEmailOutro")
  );

  // Invite request fields
  useFieldDefault(
    "inviteRequestsEnabled",
    null,
    _get(parentContractDefaults, "inviteRequestsEnabled")
  );
  useFieldDefault(
    "inviteRequestEmailsRequired",
    null,
    _get(parentContractDefaults, "inviteRequestEmailsRequired")
  );
  useFieldDefault(
    "inviteRequestType",
    null,
    _get(parentContractDefaults, "inviteRequestType")
  );
  useFieldDefault(
    "inviteRequestIntroText",
    null,
    _get(parentContractDefaults, "inviteRequestIntroText")
  );
  useFieldDefault(
    "inviteRequestDisabledText",
    null,
    _get(parentContractDefaults, "inviteRequestDisabledText")
  );
  useFieldDefault(
    "inviteRequestRoleRequired",
    null,
    _get(parentContractDefaults, "inviteRequestRoleRequired")
  );

  return null;
};

export const ContractFields = ({
  newOrg,
  parentContractDefaults,
  loadingDefaults,
  ...props
}) => {
  return (
    <>
      {newOrg && parentContractDefaults && (
        <ParentContractDefaults
          parentContractDefaults={parentContractDefaults}
        />
      )}
      {!newOrg && <ContractOrganization {...props} />}
      {!newOrg && <Divider />}
      <ContractDetailFields {...props} />
      <Divider />
      <ContractPLLFields {...props} />
      <Divider />
      <ContractActivationFields {...props} />
      <Divider />
      <ContractAutoExpireFields {...props} />
      <Divider />
      <ContractInviteRequestsFields {...props} />
      <Divider />
      <ContractSettingsFields {...props} />
    </>
  );
};

const ContractForm = ({
  editing,
  contract,
  onSubmit,
  onCancel,
  submitText
}) => {
  const classes = useStylesUtil();

  return (
    <form onSubmit={onSubmit} noValidate>
      <ContractFields editing={editing} {...contract} />
      {editing && (
        <div className={classes.justifyContentEnd}>
          <Button className={classes.mr4} onClick={onCancel} variant="outlined">
            Cancel
          </Button>
          <Button variant="contained" color="secondary" type="submit">
            {submitText}
          </Button>
        </div>
      )}
    </form>
  );
};

ContractForm.defaultProps = {
  editing: true,
  submitText: "done"
};

export default ContractForm;
